import {
  calculateDefaultPaymentForm,
  calculateDefaultBankAccountId,
  calculateDefaultCardId
} from 'src/utils/paymentMethodHelpers';
import {
  getFirstBankAccountId,
  getFirstCreditCardId
} from 'src/utils/paymentMethodAutoSelection';

export default (values, validBankAccounts = [], creditCards = []) => {
  // Calculate default payment form
  const defaultPaymentForm = calculateDefaultPaymentForm(
    values.paymentForm,
    validBankAccounts.length
  );

  // Calculate default bank account ID
  const defaultBankAccountId = calculateDefaultBankAccountId(
    values.bankAccountId,
    defaultPaymentForm,
    validBankAccounts,
    getFirstBankAccountId
  );

  // Calculate default card ID
  const defaultCardId = calculateDefaultCardId(
    values.cardId,
    defaultPaymentForm,
    creditCards,
    getFirstCreditCardId
  );

  return {
    paymentForm: values.paymentForm ?? defaultPaymentForm,
    bankAccountId: values.bankAccountId ?? defaultBankAccountId,
    secondaryBankAccountId: values.secondaryBankAccountId ?? null,
    cardId: values.cardId ?? defaultCardId
  };
};

